export default __webpack_public_path__ + "785fe4054d22451c43503bac3224ad4c.png";